import Payment from "@/models/Accounts/Shared/Payments/Payment";
import Address from '@/models/Customers/Addresses/Address';
import Schedule from '@/models/Shared/Schedule';

export default class CreatePaymentOrderRequest {
    accountId: string;
    accountType: string;
    walletId: string;
    scheme: string;
    name: string = '';
    customerAddress: Address = new Address();
    expiresAtUtc: Date;
    schedule: Schedule;
    payments: Payment[] = [];
    metadata: JSON;
}